import { t } from "@lingui/macro";

import { Seo } from "@/client/components/seo";

import { FAQSection } from "../../home/sections/faq";

export const FaqPage = () => (
  <div className="pt-16">
    <Seo
      title={t`Frequently asked questions`}
      description={t`Answers about Izicvs: finding jobs, AI applications, the autonomous agent, application tracking, data security and pricing.`}
      path="/faq"
      breadcrumb={t`Frequently asked questions`}
    />
    <FAQSection />
  </div>
);
